import React, {useState} from 'react';
import PropTypes from 'prop-types';
import {unescape} from 'lodash';
import Autosuggest from 'react-autosuggest';
import {searchResults} from 'providers/cms';
import {replaceCmsUrl} from 'cms/helpers/common';

const theme = {
  container: 'dropdown',
  containerOpen: 'open',
  input: 'form-control form-control-lg rounded pr-6',
  inputOpen: 'react-autosuggest__input--open',
  inputFocused: 'react-autosuggest__input--focused',
  suggestionsContainer: 'dropdown-menu w-1-1 py-0',
  suggestionsContainerOpen: 'react-autosuggest__suggestions-container--open',
  suggestionsList: 'list-group list-group-flush scrollable-menu',
  suggestion: 'list-group-item px-3',
  suggestionFirst: 'react-autosuggest__suggestion--first',
  suggestionHighlighted: 'bg-light',
  sectionContainer: 'react-autosuggest__section-container',
  sectionContainerFirst: 'react-autosuggest__section-container--first',
  sectionTitle: 'react-autosuggest__section-title'
};
const getSuggestion = ({post_title}) => unescape(post_title);

const SearhAutosuggest = ({type, wrapperClass, iconClass, placeholderSearch, notFound}) => {
  const [searchText, setSearchText] = useState('');
  const [suggestionsIsLoading, setSuggestionsIsLoading] = useState(false);
  const [suggestions, setSuggestions] = useState([]);

  const clearSuggestions = () => {
    setSuggestions([]);
  };

  const fetchSuggestions = async (value) => {
    if (value.length < 3) {
      return;
    }

    setSuggestionsIsLoading(true);
    const {body} = await searchResults(value, type);
    setSuggestions(body.length === 0 ? [{post_title: notFound}] : body);
    setSuggestionsIsLoading(false);
  };

  const onSuggestionSelected = ({permanlink}) => {
    if (permanlink) {
      location.href = replaceCmsUrl(permanlink);
    } else {
      setSearchText('');
    }
  };

  return (
    <div className={`position-relative w-1-1 cursor-pointer ${wrapperClass}`}>
      <Autosuggest
        theme={{...theme}}
        inputProps={{
          type: 'search',
          placeholder: placeholderSearch,
          value: searchText,
          onChange: (ignore, {newValue}) => setSearchText(newValue)
        }}
        suggestions={suggestions}
        onSuggestionsFetchRequested={({value}) => fetchSuggestions(value)}
        onSuggestionsClearRequested={() => clearSuggestions()}
        getSuggestionValue={getSuggestion}
        renderSuggestion={getSuggestion}
        onSuggestionSelected={(event, {suggestion}) => onSuggestionSelected(suggestion)}
      />
      <div className="autosuggestLoading bg-transparent">
        <i className={`icon ${iconClass} ${suggestionsIsLoading ? 
          'icon icon-dots-anim-2 icon-is-spinning' : 'icon-magnifier'}`}/>
      </div>
    </div>
  );
};

SearhAutosuggest.propTypes = {
  type: PropTypes.string.isRequired,
  wrapperClass: PropTypes.string.isRequired,
  iconClass: PropTypes.string.isRequired,
  placeholderSearch: PropTypes.string.isRequired,
  notFound: PropTypes.string.isRequired
};

SearhAutosuggest.defaultProps = {
  wrapperClass: '',
  iconClass: ''
};

export default SearhAutosuggest;
